// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const mantine: PokeData = {
  "id": 226,
  "name": "mantine",
  "height": 21,
  "weight": 2200,
  "base_experience": 170,
  "types": [
    PokeType.WATER,
    PokeType.FLYING
  ],
  "api_moves": [
    "wing-attack",
    "headbutt",
    "tackle",
    "take-down",
    "double-edge",
    "supersonic",
    "water-gun",
    "hydro-pump",
    "psybeam",
    "bubble-beam",
    "agility",
    "confuse-ray",
    "bubble",
    "signal-beam",
    "bullet-seed",
    "aerial-ace",
    "bounce",
    "water-pulse",
    "roost",
    "aqua-ring",
    "air-slash",
    "wide-guard"
  ],
  "moves": [
    "headbutt",
    "tackle",
    "supersonic",
    "hydro-pump",
    "bubble-beam",
    "confuse-ray",
    "bubble",
    "bullet-seed",
    "aerial-ace",
    "roost",
    "air-slash",
    "whirlpool",
    "peck"
  ],
  "evolution_chain": {
    "id": 116,
    "item": {
      "name": "wave-incense"
    },
    "species": [
      {
        "name": "mantyke",
        "order": 258,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "mantine",
        "order": 259,
        "types": [
          PokeType.WATER,
          PokeType.FLYING
        ],
        "evolves_from_species_id": 458,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 155,
    "speed": 114,
    "ability_power": 131
  },
  "stat_changes": [],
  "catch_rate": 25,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
